import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const SectionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.625rem 0.125rem;
  font-size: ${tokens.font.label};
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: ${tokens.text.muted};
`

export const SectionCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.375rem;
  border-radius: 999px;
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  font-size: ${tokens.font.micro};
  font-weight: 600;
  letter-spacing: 0;
  color: ${tokens.text.secondary};
`

export const CampList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const CampCard = styled.div<{ $active?: boolean }>`
  background: ${tokens.surface.glass};
  backdrop-filter: blur(${tokens.blur});
  border: 1px solid ${(props) => (props.$active ? tokens.border.strong : tokens.border.hairline)};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
  overflow: hidden;
  transition: border-color 0.2s ease;
`

export const CampHeader = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: ${tokens.surface.inset};
  }
`

export const CampIdentity = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
`

export const CampName = styled.div`
  font-size: ${tokens.font.h2};
  font-weight: 600;
  color: ${tokens.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CampMeta = styled.div`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const CampKpis = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex: none;
`

export const CampKpi = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.1rem;
  line-height: 1.1;

  @media (max-width: 560px) {
    &:nth-of-type(3) {
      display: none;
    }
  }
`

export const CampKpiValue = styled.div<{ $color?: string }>`
  font-size: ${tokens.font.h2};
  font-weight: 600;
  color: ${(props) => props.$color ?? tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const CampKpiLabel = styled.div`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
  letter-spacing: 0.03em;
`

export const ChevronBox = styled.div`
  display: grid;
  place-items: center;
  width: 1.25rem;
  flex: none;

  .chevron {
    transition: transform 0.25s ${tokens.motion.ease};
  }
`

export const CampCollapse = styled.div<{ $open?: boolean }>`
  display: grid;
  grid-template-rows: ${(props) => (props.$open ? '1fr' : '0fr')};
  transition: grid-template-rows 0.28s ${tokens.motion.ease};
`

export const CampCollapseInner = styled.div`
  min-height: 0;
  overflow: hidden;
`
